import { useOnBlock } from "./useOnBlock";

export function useBlockNumber() {
  const blockNumber = useOnBlock();
  return { data: blockNumber };
}
